module.exports = __webpack_public_path__ + "img/emoji_sad.0b8d0b20.svg";